import { RootState } from '..'

const archivePageView = (state: RootState) => state?.appConfig?.archivePage
const caseAttachmentsView = (state: RootState) => state?.appConfig?.caseAttachmentsPage
const caseInboxPageView = (state: RootState) => state?.appConfig?.caseInboxPage

export default {
  archivePageView,
  caseAttachmentsView,
  caseInboxPageView,
}
